import { Component } from '@angular/core';
import { CoreService, PageTitleService } from '@core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { MaterialModule } from '../../material.module';

@Component({
  selector: 'app-blank',
  templateUrl: './blank.component.html',
  styleUrls: [],
  imports: [RouterOutlet, MaterialModule, CommonModule],
})
export class BlankComponent {
  private htmlElement!: HTMLHtmlElement;

   get options():any {
    return this.settings.getOptions();
  }

  constructor(private settings: CoreService, private pageTitleService: PageTitleService) {
    this.htmlElement = document.querySelector('html')!;
  }
}
